import React, { useState, useEffect } from "react";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonModal,
  IonText,
  IonTitle,
  IonToolbar,
  useIonToast,
  IonCol,
} from "@ionic/react";
import {
  notificationsOutline,
  mailOutline,
  copyOutline,
  shareOutline,
  shareSocialOutline,
  arrowBackOutline,
} from "ionicons/icons";
import { Document } from "../../@types/document";
import { selectSigners } from "../../store/documentShow/selectors/selectSigners";
import { useSelector, useDispatch } from "react-redux";
import { findSigners } from "../../store/documentShow/actions/findSigners";
import { notifySigner } from "../../store/documentShow/actions/notifySigner";
import { DocumentStakeholder } from "../../@types/documentStakeholder";
import "../../theme/styles.css";

interface ComponentProps {
  document: Document;
}

export const DocumentShare: React.FC<ComponentProps> = ({ document }) => {
  const dispatch = useDispatch();
  const signers = useSelector(selectSigners);
  const [showNotifyModal, setShowNotifyModal] = useState(false);
  const [shareIcon, setShareIcon] = useState("");
  const [presentToast, hideToast] = useIonToast();
  const urlNotify = `https://mi.guardservice.cl/app/acuerdos/firma/${document.id}`;
  const getStakeholders = () => {
    dispatch(findSigners(`${document.id}`));
    setShowNotifyModal(true);
  };
  const firstPendingStakeholder = signers.filter(({ status }) => status?.code === "pending");
  const handleCopyLink = async () => {
    try {
      navigator.clipboard.writeText(urlNotify);
      await hideToast();
      presentToast({
        message: `Enlace copiado exitosamente`,
        color: "success",
        duration: 8000,
      });
    } catch (err) {
      presentToast({
        message: "Ocurrió un problema copiando enlace",
        color: "danger",
        duration: 8000,
      });
    }
  };

  const handleSendNotification = async (documentStakeholder: DocumentStakeholder) => {
    try {
      await hideToast();
      presentToast({
        message: `Reenviando notificación...`,
        color: "primary",
      });
      const { payload: notificationCreated }: any =
        (await dispatch(notifySigner(documentStakeholder))) || {};
      if (!notificationCreated) {
        throw new Error("No se envió la notificación");
      }

      await hideToast();
      presentToast({
        message: `Se envió una notificación a ${documentStakeholder.stakeholder?.name} para que firme el acuerdo`,
        color: "success",
        duration: 8000,
      });
    } catch (error) {
      await hideToast();
      presentToast({
        message: "Ocurrió un problema enviando notificación al firmante",
        color: "danger",
        duration: 8000,
      });
    }
  };

  const shareLink = () => {
    if (navigator.share === undefined) {
      handleCopyLink();
    } else {
      navigator
        .share({
          title: "",
          text: "Te comparto el link directo para que firmes el documento",
          url: `${urlNotify}`,
        })
        .then(function () {
          console.log("Successful share");
        })
        .catch(function (error) {
          console.log("Error sharing:", error);
        });
    }
  };

  useEffect(() => {
    if (navigator.share === undefined) {
      setShareIcon(copyOutline);
    } else {
      setShareIcon(shareSocialOutline);
    }
  }, []);

  return (
    <>
      <IonCol className="columnaShare ion-hide-md-down" sizeLg="3" sizeMd="3" sizeXs="3">
        <IonButton
          size="small"
          fill="solid"
          color="primary"
          onClick={() => {
            getStakeholders();
          }}
          icon-only="true"
        >
          <IonIcon icon={mailOutline} style={{ fontSize: 14 }}></IonIcon>
        </IonButton>
        <IonButton
          size="small"
          fill="solid"
          color="primary"
          onClick={() => {
            shareLink();
          }}
          icon-only="true"
        >
          <IonIcon icon={shareIcon} style={{ fontSize: 14 }}></IonIcon>
        </IonButton>
      </IonCol>

      {firstPendingStakeholder.map((documentStakeholder, index) => (
        <IonModal
          key={`item-${index}`}
          isOpen={showNotifyModal}
          onWillDismiss={() => setShowNotifyModal(false)}
        >
          <IonToolbar>
            <IonTitle>
              <IonIcon
                className="btn-close"
                icon={arrowBackOutline}
                onClick={() => setShowNotifyModal(false)}
              />{" "}
              Notificar a firmante
            </IonTitle>
          </IonToolbar>
          <IonContent>
            <h4 className="ion-padding-start">
              <IonText>Opciones</IonText>
            </h4>
            <IonItem>
              <IonLabel class="ion-text-nowrap">
                <h2 style={{ fontWeight: 500 }}>
                  Enviar correo a {documentStakeholder?.stakeholder?.name}
                </h2>
                <p>
                  Enviar enlace al correo del firmante
                  <strong>({documentStakeholder?.stakeholder?.email})</strong>
                </p>
              </IonLabel>
              <IonButtons slot="end">
                <IonButton
                  onClick={() => {
                    handleSendNotification(documentStakeholder);
                  }}
                  fill="solid"
                  color="primary"
                >
                  <span>Enviar</span>
                  <IonIcon icon={mailOutline} slot="end"></IonIcon>
                </IonButton>
              </IonButtons>
            </IonItem>

            <IonItem>
              <IonLabel>
                <h2 style={{ fontWeight: 500 }}>Obtener enlace para envío manual</h2>
                <p>
                  <strong>{urlNotify}</strong>
                </p>
              </IonLabel>
              <IonButtons slot="end">
                <IonButton
                  onClick={() => {
                    handleCopyLink();
                  }}
                  fill="solid"
                  color="primary"
                >
                  <span>Copiar</span>
                  <IonIcon icon={copyOutline} slot="end"></IonIcon>
                </IonButton>
              </IonButtons>
            </IonItem>
          </IonContent>
        </IonModal>
      ))}
    </>
  );
};
